/* KOSAI 360 Vitrine (sections/kosai-vitrine-360.liquid) */
(() => {
if (customElements.get('kosai-vitrine-360')) return;
const reduced = matchMedia('(prefers-reduced-motion: reduce)');
const wait = (ms) => new Promise((r) => setTimeout(r, ms));
const pub = (name, data) => { try { window.Shopify?.analytics?.publish?.(name, data); } catch (e) {} };
const lowData = () => { const c = navigator.connection; return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))); };
const loadImage = (src) => new Promise((resolve, reject) => {
const img = new Image();
img.decoding = 'async';
img.onload = () => (img.decode ? img.decode().catch(() => {}) : Promise.resolve()).then(() => resolve(img));
img.onerror = () => reject(new Error('image failed: ' + src));
img.src = src;
});
const focusVisibleWithin = (el) => { try { return !!el.querySelector(':focus-visible'); } catch (e) { return false; } };
const VIEW_NAMES = ['Front view', 'Three-quarter view', 'Side view', 'Three-quarter back view', 'Back view', 'Three-quarter back view', 'Side view', 'Three-quarter view'];
class KosaiVitrine360 extends HTMLElement {
connectedCallback() {
if (this.inited) return;
if (this.querySelector('[data-stage]') || document.readyState !== 'loading') { this.init(); return; }
document.addEventListener('DOMContentLoaded', () => { if (this.isConnected && !this.inited) this.init(); }, { once: true });
}
disconnectedCallback() { this.destroy(); }
init() {
const $ = (s) => this.querySelector(s);
this.stage = $('[data-stage]');
if (!this.stage) return;
this.inited = true;
this.wrap = $('.kv__stagewrap');
this.canvas = $('.kv__canvas');
this.ctx = this.canvas.getContext('2d');
this.poster = $('.kv__poster');
this.detailImg = $('[data-detail-img]');
this.details = $('.kv__details');
this.note = $('[data-note]');
this.live = $('[data-live]');
this.loadBtn = $('[data-load]');
this.bar = $('.kv__progress span');
this.deg = $('[data-deg]');
this.errorMsg = $('[data-error]');
this.resetBtn = $('[data-act="reset"]');
this.pauseBtn = $('[data-act="pause"]');
this.tabs = [...this.querySelectorAll('.kv__tab')];
this.bags = new Map(this.tabs.map((t) => [t.dataset.bag, this.readBag(t)]));
const first = this.tabs.find((t) => t.getAttribute('aria-pressed') === 'true') || this.tabs[0];
this.bag = first ? this.bags.get(first.dataset.bag) : this.readBag(document.createElement('button'));
this.pos = this.bag.start;
this.vel = 0;
this.resumeAt = 0;
this.last = 0;
this.glide = this.dragging = this.activeChip = this.pending = this.nextBag = null;
this.gateOpened = this.activated = this.firstLoad = this.stopped = false;
this.switchToken = 0;
this.design = window.Shopify?.designMode === true;
this.rotateSeconds = Math.max(6, +this.dataset.rotateSeconds || 16);
this.onscreen = false;
this.on(this.stage, 'pointerdown', (e) => this.onDown(e));
this.on(this.stage, 'pointermove', (e) => this.onMove(e));
['pointerup', 'pointercancel', 'lostpointercapture'].forEach((n) => this.on(this.stage, n, (e) => this.onUp(e)));
this.on(this.stage, 'click', () => this.onStageClick());
this.on(this.stage, 'keydown', (e) => this.onKey(e));
this.on(this.stage, 'dragstart', (e) => e.preventDefault());
if (this.loadBtn) this.on(this.loadBtn, 'click', () => { this.activate(); this.stage.focus({ preventScroll: true }); });
this.querySelectorAll('[data-act]').forEach((b) => this.on(b, 'click', () => this.onAct(b.dataset.act)));
this.tabs.forEach((t, i) => {
this.on(t, 'click', () => this.selectBag(t.dataset.bag));
this.on(t, 'keydown', (e) => this.onTabKey(e, i));
['pointerenter', 'focus'].forEach((n) => this.on(t, n, () => this.prefetch(this.bags.get(t.dataset.bag))));
});
this.querySelectorAll('.kv__chip').forEach((c) => {
this.on(c, 'click', () => this.selectDetail(c));
['pointerenter', 'focus'].forEach((n) => this.on(c, n, () => { if (c.dataset.img) new Image().src = c.dataset.img; }, { once: true }));
});
this.on(this, 'keydown', (e) => { if (e.key === 'Escape' && this.activeChip) this.clearDetail(true); });
this.on(this, 'focusout', () => this.kick());
this.on(document, 'visibilitychange', () => this.kick());
this.on(reduced, 'change', () => { this.syncPause(); this.kick(); });
this.on(document, 'shopify:section:unload', (e) => { if (e.detail?.sectionId === this.dataset.sectionId) this.destroy(); });
this.on(document, 'shopify:block:select', (e) => {
if (e.detail?.sectionId !== this.dataset.sectionId) return;
if (this.bags.has(e.detail.blockId)) this.selectBag(e.detail.blockId, true);
});
this.ro = new ResizeObserver(() => { this.fitFrame(); this.draw(); });
this.ro.observe(this.stage);
this.fitFrame();
this.io = new IntersectionObserver((entries) => {
this.onscreen = entries[entries.length - 1].isIntersecting;
if (this.onscreen && !this.gateOpened) this.gate();
this.kick();
}, { rootMargin: '300px 0px' });
this.io.observe(this.stage);
this.applyStatic();
this.syncPause();
this.syncA11y();
}
on(target, name, fn, opts) {
(this.handlers ||= []).push([target, name, fn, opts]);
target.addEventListener(name, fn, opts);
}
destroy() {
if (!this.inited) return;
this.inited = false;
(this.handlers || []).forEach(([t, n, f, o]) => t.removeEventListener(n, f, o));
this.handlers = [];
this.io?.disconnect();
this.ro?.disconnect();
cancelAnimationFrame(this.raf);
this.raf = 0;
this.last = 0;
clearTimeout(this.resumeTimer);
this.gateOpened = this.activated = this.firstLoad = false;
this.dragging = this.glide = this.pending = this.activeChip = this.nextBag = null;
this.stage?.classList.remove('is-live', 'is-loading', 'is-detail', 'is-switching', 'is-grabbing', 'is-error');
this.wrap?.classList.remove('is-ready');
this.querySelectorAll('.kv__chip[aria-pressed="true"]').forEach((c) => c.setAttribute('aria-pressed', 'false'));
}
readBag(tab) {
const parse = (v) => { try { return JSON.parse(v || '[]').filter(Boolean); } catch (e) { return []; } };
const sheets = parse(tab.dataset.sheets);
const sheetsSmall = parse(tab.dataset.sheetsSmall);
const cols = Math.max(1, +tab.dataset.cols || 5);
const rows = Math.max(1, +tab.dataset.rows || 5);
const capacity = sheets.length * cols * rows;
const frames = Math.min(capacity, Math.max(2, +tab.dataset.frames || capacity));
return {
id: tab.dataset.bag, title: tab.dataset.title || '', sheets, sheetsSmall, cols, rows, frames,
start: Math.min(Math.max(0, frames - 1), Math.max(0, +tab.dataset.start || 0)),
dir: tab.dataset.dir === '-1' ? -1 : 1,
size: tab.dataset.size || '', poster: tab.dataset.poster || '', posterSrcset: tab.dataset.posterSrcset || '',
productId: tab.dataset.productId || '', images: null, loading: null, failed: false,
};
}
isStatic(bag = this.bag) { return !bag.sheets.length || bag.frames < 2; }
applyStatic() {
const s = this.isStatic();
this.stage.classList.toggle('is-static', s);
this.wrap.classList.toggle('is-static', s);
if (s) {
['tabindex', 'role', 'aria-valuemin', 'aria-valuemax', 'aria-valuenow', 'aria-valuetext', 'aria-label'].forEach((a) => this.stage.removeAttribute(a));
return;
}
this.stage.setAttribute('tabindex', '0');
this.stage.setAttribute('role', 'slider');
this.stage.setAttribute('aria-valuemin', '0');
this.stage.setAttribute('aria-valuemax', '359');
this.stage.setAttribute('aria-label', `${this.bag.title ? 'Turn ' + this.bag.title : 'Turn the piece'}. Drag, or use the arrow keys.`);
}
gate() {
this.gateOpened = true;
if (this.isStatic()) return;
if (this.dataset.policy === 'on_click' || lowData()) { this.showLoadButton(); return; }
const go = () => { if (this.inited && !this.activated) this.activate(); };
if (this.design) return go();
const idle = () => ('requestIdleCallback' in window ? requestIdleCallback(go, { timeout: 1500 }) : setTimeout(go, 200));
document.readyState === 'complete' ? idle() : addEventListener('load', idle, { once: true });
}
showLoadButton() {
if (!this.loadBtn || this.isStatic() || this.bag.images) return;
this.loadBtn.querySelector('[data-size]').textContent = this.bag.size ? ' · ' + this.bag.size : '';
this.loadBtn.hidden = false;
}
sheetUrls(bag) {
const small = bag.sheetsSmall.length === bag.sheets.length && this.stage.clientWidth * Math.min(devicePixelRatio || 1, 2) <= 640;
return small ? bag.sheetsSmall : bag.sheets;
}
load(bag, { progress = false } = {}) {
if (bag.images) return Promise.resolve(bag.images);
if (bag.loading) return bag.loading;
const urls = this.sheetUrls(bag);
let done = 0;
if (progress) { this.stage.classList.add('is-loading'); this.bar.style.transform = 'scaleX(.06)'; }
bag.loading = Promise.all(urls.map((u) => loadImage(u).then((img) => {
done += 1;
if (progress && this.bag === bag) this.bar.style.transform = `scaleX(${done / urls.length})`;
return img;
}))).then((imgs) => { bag.images = imgs; bag.failed = false; return imgs; })
.finally(() => { bag.loading = null; if (progress) this.stage.classList.remove('is-loading'); });
return bag.loading;
}
prefetch(bag) {
if (!bag || this.isStatic(bag) || bag.images || bag.loading || !this.activated || lowData()) return;
this.load(bag).catch(() => {});
}
activate() {
if (this.isStatic()) return Promise.resolve();
this.activated = true;
if (this.loadBtn) this.loadBtn.hidden = true;
const bag = this.bag;
return this.load(bag, { progress: true }).then(() => {
if (this.bag !== bag || !this.inited) return;
this.stage.classList.remove('is-error');
this.errorMsg.hidden = true;
this.stage.classList.add('is-live');
this.wrap.classList.add('is-ready');
this.fitFrame();
this.draw();
this.syncA11y();
if (!this.firstLoad) { this.firstLoad = true; this.pauseRotate(1400); pub('kosai_360_loaded', { product_id: bag.productId }); }
if (this.pending) { const c = this.pending; this.pending = null; this.selectDetail(c); }
}).catch(() => {
bag.failed = true;
if (this.bag !== bag || !this.inited) return;
this.stage.classList.add('is-error');
this.errorMsg.hidden = false;
if (this.pending) { const c = this.pending; this.pending = null; this.selectDetail(c); }
});
}
fitFrame() {
this.stage.style.setProperty('--kv-sq', Math.min(this.stage.clientWidth, this.stage.clientHeight) + 'px');
}
draw() {
const bag = this.bag;
if (!bag || !bag.images) return;
const c = this.canvas;
const size = Math.round(c.clientWidth * Math.min(devicePixelRatio || 1, 2));
if (!size) return;
if (c.width !== size) { c.width = size; c.height = size; }
const n = bag.frames;
const p = ((this.pos % n) + n) % n;
const i0 = Math.floor(p), f = p - i0;
this.ctx.globalAlpha = 1;
this.blit(bag, i0, size);
if (f > 0.02) { this.ctx.globalAlpha = f; this.blit(bag, (i0 + 1) % n, size); this.ctx.globalAlpha = 1; }
}
blit(bag, i, size) {
const per = bag.cols * bag.rows;
const sheet = bag.images[Math.floor(i / per)];
if (!sheet) return;
const k = i % per;
const fw = sheet.naturalWidth / bag.cols, fh = sheet.naturalHeight / bag.rows;
this.ctx.drawImage(sheet, (k % bag.cols) * fw, Math.floor(k / bag.cols) * fh, fw, fh, 0, 0, size, size);
}
angle() {
const n = this.bag.frames || 1;
const rel = ((((this.bag.start - this.pos) * this.bag.dir) % n) + n) % n;
return Math.round((rel / n) * 360) % 360;
}
syncA11y(aria = true) {
const a = this.angle();
if (this.deg) this.deg.textContent = a + '°';
if (!aria || this.isStatic()) return;
this.stage.setAttribute('aria-valuenow', a);
this.stage.setAttribute('aria-valuetext', `${VIEW_NAMES[Math.round(a / 45) % 8]}, ${a} degrees`);
}
syncPause() {
if (!this.pauseBtn) return;
this.pauseBtn.hidden = reduced.matches || this.design || this.dataset.rotate !== 'true';
this.pauseBtn.setAttribute('aria-pressed', String(this.stopped));
}
kick() { if (!this.raf && this.inited) this.raf = requestAnimationFrame((t) => this.tick(t)); }
rotating() {
return this.dataset.rotate === 'true' && !this.stopped && !reduced.matches && !this.design && this.onscreen && !document.hidden
&& !this.activeChip && !this.dragging && !this.nextBag && !!this.bag.images && performance.now() >= this.resumeAt
&& !focusVisibleWithin(this);
}
pauseRotate(ms = 4000) {
this.resumeAt = performance.now() + ms;
clearTimeout(this.resumeTimer);
this.resumeTimer = setTimeout(() => this.kick(), ms + 20);
}
tick(t) {
this.raf = 0;
const dt = Math.min(64, t - (this.last || t));
this.last = t;
let active = false;
if (this.glide) {
const g = this.glide;
const k = Math.min(1, (t - g.t0) / g.dur);
this.pos = g.from + (g.to - g.from) * (1 - Math.pow(1 - k, 3));
if (k < 1) active = true; else { this.glide = null; g.done?.(); }
} else if (!this.dragging && Math.abs(this.vel) > 0.0015) {
this.pos += this.vel * dt;
this.vel *= Math.pow(0.92, dt / 16);
active = true;
} else if (this.rotating()) {
this.pos += this.bag.dir * (this.bag.frames / (this.rotateSeconds * 1000)) * dt;
active = true;
}
this.draw();
this.syncA11y(!active);
if (active) this.kick(); else this.last = 0;
}
glideTo(frame, done) {
const n = this.bag.frames;
let delta = ((frame - this.pos) % n + n) % n;
if (delta > n / 2) delta -= n;
this.vel = 0;
if (reduced.matches || Math.abs(delta) < 0.05) { this.pos += delta; this.draw(); this.syncA11y(); done?.(); return; }
this.glide = { from: this.pos, to: this.pos + delta, t0: performance.now(), dur: 380 + Math.abs(delta) * 28, done };
this.kick();
}
onStageClick() {
if (this.isStatic() || this.bag.images || this.bag.loading) return;
if (this.loadBtn && !this.loadBtn.hidden) return;
if (!this.activated || this.bag.failed) this.activate();
}
onDown(e) {
if (e.button > 0 || this.isStatic() || !this.bag.images) return;
this.vel = 0;
this.dragging = { x: e.clientX, y: e.clientY, pos: this.pos, lastX: e.clientX, lastT: performance.now(), locked: false, id: e.pointerId };
}
lock(e) {
const d = this.dragging;
d.locked = true;
this.glide = null;
d.pos = this.pos;
d.x = d.lastX = e.clientX;
d.lastT = performance.now();
try { this.stage.setPointerCapture(e.pointerId); } catch (err) {}
this.stage.classList.add('is-grabbing');
if (this.activeChip) this.clearDetail(false);
this.markMoved();
}
onMove(e) {
const d = this.dragging;
if (!d || e.pointerId !== d.id) return;
if (!d.locked) {
const dx = e.clientX - d.x, dy = e.clientY - d.y;
if (e.pointerType === 'mouse') {
if (Math.abs(dx) < 3) return;
} else {
if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
if (Math.abs(dy) > Math.abs(dx)) { this.dragging = null; return; }
}
this.lock(e);
return;
}
const perFrame = Math.max(4, this.stage.clientWidth / (this.bag.frames * 0.7));
const now = performance.now();
this.pos = d.pos - ((e.clientX - d.x) / perFrame) * this.bag.dir;
const v = -((e.clientX - d.lastX) / perFrame) * this.bag.dir / Math.max(8, now - d.lastT);
this.vel = this.vel * 0.5 + v * 0.5;
d.lastX = e.clientX;
d.lastT = now;
this.draw();
this.syncA11y(false);
}
onUp(e) {
const d = this.dragging;
if (!d || (e.pointerId !== undefined && e.pointerId !== d.id)) return;
this.dragging = null;
this.stage.classList.remove('is-grabbing');
if (!d.locked || reduced.matches || performance.now() - d.lastT > 80) this.vel = 0;
this.vel = Math.max(-0.04, Math.min(0.04, this.vel));
if (d.locked) { this.pauseRotate(); this.syncA11y(); }
this.kick();
}
onKey(e) {
if (this.isStatic()) return;
const steps = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1 };
if (e.key in steps) {
e.preventDefault();
if (!this.bag.images) { if (!this.bag.loading) this.activate(); return; }
this.markMoved();
if (this.activeChip) this.clearDetail(false);
this.pauseRotate();
this.glideTo(Math.round(this.pos) - steps[e.key] * this.bag.dir * 2);
} else if (e.key === 'Home') {
e.preventDefault();
this.onAct('reset');
}
}
onAct(act) {
if (act === 'pause') {
this.stopped = !this.stopped;
this.syncPause();
if (!this.stopped) { this.resumeAt = 0; this.kick(); }
return;
}
if (this.isStatic()) return;
if (!this.bag.images) { if (!this.bag.loading) this.activate(); return; }
this.pauseRotate();
if (act === 'reset') {
this.clearDetail(false);
this.glideTo(this.bag.start);
this.classList.remove('is-moved');
this.resetBtn.hidden = true;
return;
}
this.markMoved();
if (this.activeChip) this.clearDetail(false);
const eighth = this.bag.frames / 8;
this.glideTo(Math.round(this.pos) + (act === 'left' ? eighth : -eighth) * this.bag.dir);
}
markMoved() {
this.stopped = true;
this.syncPause();
if (this.classList.contains('is-moved')) return;
this.classList.add('is-moved');
this.resetBtn.hidden = false;
pub('kosai_360_interact', { product_id: this.bag.productId });
}
selectDetail(chip) {
if (this.nextBag) return;
if (chip === this.activeChip) return this.clearDetail(true);
if (!this.isStatic() && !this.bag.images && !this.bag.failed) {
this.pending = chip;
this.note.textContent = chip.dataset.text || chip.textContent.trim();
if (!this.bag.loading) this.activate();
return;
}
this.clearDetail(false, true);
this.activeChip = chip;
chip.parentElement.querySelectorAll('.kv__chip').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
this.note.textContent = chip.dataset.text || chip.textContent.trim();
const show = () => {
if (this.activeChip !== chip || !chip.dataset.img) return;
const img = this.detailImg;
const reveal = () => { if (this.activeChip === chip) this.stage.classList.add('is-detail'); };
if (img.getAttribute('src') === chip.dataset.img && img.complete) return reveal();
img.onload = reveal;
img.src = chip.dataset.img;
};
if (this.bag.images) this.glideTo(+chip.dataset.frame || 0, show); else show();
pub('kosai_360_detail', { product_id: this.bag.productId, label: chip.textContent.trim() });
}
clearDetail(toStart, keepNote) {
const chip = this.activeChip;
if (!chip) return;
this.activeChip = null;
chip.setAttribute('aria-pressed', 'false');
this.stage.classList.remove('is-detail');
if (!keepNote) this.note.textContent = '';
if (toStart && this.bag.images) this.glideTo(this.bag.start);
this.pauseRotate();
}
async selectBag(id, instant = false) {
const bag = this.bags.get(id);
if (!bag || bag === (this.nextBag || this.bag)) return;
const token = ++this.switchToken;
this.nextBag = bag;
this.clearDetail(false);
this.pending = null;
this.note.textContent = '';
this.tabs.forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.bag === id)));
this.querySelectorAll('[data-bag]:not(.kv__tab)').forEach((el) => { el.hidden = el.dataset.bag !== id; });
if (this.details) this.details.hidden = !this.querySelector(`.kv__dgroup[data-bag="${CSS.escape(id)}"]`);
if (!(instant || reduced.matches)) {
this.stage.classList.add('is-switching');
await wait(240);
if (token !== this.switchToken) return;
}
this.bag = bag;
this.nextBag = null;
this.clearDetail(false);
this.pending = null;
this.glide = this.dragging = null;
this.vel = 0;
this.pos = bag.start;
this.classList.remove('is-moved');
this.resetBtn.hidden = true;
this.stage.classList.remove('is-live', 'is-error', 'is-grabbing');
this.errorMsg.hidden = true;
this.wrap.classList.remove('is-ready');
if (bag.images) { this.stage.classList.add('is-live'); this.wrap.classList.add('is-ready'); this.draw(); }
if (this.poster) {
this.poster.hidden = !bag.poster;
if (bag.poster) {
this.poster.loading = 'eager';
if (bag.posterSrcset) this.poster.srcset = bag.posterSrcset; else this.poster.removeAttribute('srcset');
this.poster.src = bag.poster;
this.poster.alt = bag.title;
await Promise.race([this.poster.decode ? this.poster.decode().catch(() => {}) : Promise.resolve(), wait(800)]);
if (token !== this.switchToken) return;
} else {
this.poster.removeAttribute('srcset');
this.poster.removeAttribute('src');
this.poster.alt = '';
}
}
this.applyStatic();
this.stage.classList.remove('is-switching');
if (bag.title) this.live.textContent = `Now showing ${bag.title}`;
this.syncA11y();
if (this.activated && !this.isStatic()) this.activate();
else if (this.loadBtn && !this.loadBtn.hidden) this.showLoadButton();
this.pauseRotate(1400);
pub('kosai_360_switch', { product_id: bag.productId });
}
onTabKey(e, i) {
const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
let next = null;
if (e.key in keys) next = (i + keys[e.key] + this.tabs.length) % this.tabs.length;
else if (e.key === 'Home') next = 0;
else if (e.key === 'End') next = this.tabs.length - 1;
if (next === null) return;
e.preventDefault();
this.tabs[next].focus();
}
}
customElements.define('kosai-vitrine-360', KosaiVitrine360);
})();
